// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/depositi?societaId=',
    requestBody: null,
    response: '{ depositi: [{ id, nome, tipo }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/giacenze?societaId=&depositoId=&soloMovimentati=',
    requestBody: null,
    response: '{ success: true, data: [{ id, deposito, articolo, quantita, cmp, updatedAt }] }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
